import parse from "url-parse";

import { RECEIVE_WELCOME_MESSAGE } from "./constants";

import {
  correctInvalidKeyStoreDataversion,
  finishSettingCustomAttributeFromPreviousRequest
} from "./invalidKeyStoreDataversionHandling";

export const requestWelcomeMessage = (platform, alternateUrls) => {
  return (dispatch, getState, { api }) => {
    const { regionalStore } = getState();
    const { keyStoreDataversion, countryCode } = regionalStore;
    const { fetchWelcomeMessage } = api;

    fetchWelcomeMessage(countryCode, platform, keyStoreDataversion)
      .then(res => {
        finishSettingCustomAttributeFromPreviousRequest();

        if (res.browsingLocalStore) {
          dispatch({ type: RECEIVE_WELCOME_MESSAGE, payload: res });
          return;
        }

        const {
          country: { defaultLanguage }
        } = res;

        const useQuerystringifyParser = true;
        res.redirectUrl.url = parse(
          alternateUrls[defaultLanguage] || `//${res.redirectUrl.url}`,
          useQuerystringifyParser
        );

        dispatch({ type: RECEIVE_WELCOME_MESSAGE, payload: res });
      })
      .catch(error => {
        if (
          error.status === 400 &&
          error.responseText.includes('errorCode":"STR003"')
        ) {
          correctInvalidKeyStoreDataversion();
        }
      });
  };
};
